import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import GroupAbout from './indexContainer';
import GroupAboutV3 from '../GroupAbout.editor_gruser_about';

export default withFeatureBranch({
  editor_gruser_about: GroupAboutV3,
})(GroupAbout);
